export default __webpack_public_path__ + "static/media/chevron-right.81721e11.svg";